import React, { useEffect, useRef, useState } from 'react';
import CalendarWeek from '../Form/CalendarWeek';
import TimeLineItem from './TimeLineItem';
import './TimeLine.scss';
import { Button } from 'primereact/button';
import { getCalendarioOperativoSemanal, getCalendarioOperativoSemanalCalendar, getCalendarioOperativoSemanalPartida } from '../../API/Global/CalendarioOperativo/CalendarioOperativoRequest';
import { InputText } from 'primereact/inputtext';
import Loader from '../Loader/Loader';
import { SplitButton } from 'primereact/splitbutton';
import Icon from '../Icon/Icon';

const TimeLine = ({
    data,
    dates,
    setDates,
    getDetails,
    bodyItemContent,
    childBodyItemContent,
    titleItem,
    childTitleItem,
    loading,
    shortSplitButton,
    getInfo = () => { },
    timeLineConfig,
    setTimeLineConfig = () => { },
    chageSortDirection = () => { },
}) => {
    const [periodos, setPeriodos] = useState([]);
    // const [data, setData] = useState([]);
    const [noDays, setNoDays] = useState(0);
    const [totalWidth, setTotalWidth] = useState(0);
    const [tipoPeriodo, setTipoPeriodo] = useState('mesesCalendarioOperativo'); // Controla el tipo de periodo
    const [showAllChildren, setsShowAllChildren] = useState(false);
    const [filter, setFilter] = useState('');
    const [dataFiltrada, setDataFiltrada] = useState(data);

    const milisecondsInADay = 1000 * 60 * 60 * 24;
    const valChangeWidthDay = 1;

    const heightHeaderLine = 25; // Altura de la línea del encabezado
    const headerheight = (timeLineConfig?.showDays ? heightHeaderLine : 0) + (timeLineConfig?.showWeeks ? heightHeaderLine : 0) + (timeLineConfig?.showMonths ? heightHeaderLine : 0);
    const scrollHorizontalRef = useRef(null);
    const [dividerPosition, setDividerPosition] = useState(300);

    const [calendar, setCalendar] = useState([]);

    const deffPeriodos = async () => {
        if (dates[0] && dates[1]) {
            const startDate = new Date(dates[0]);
            const endDate = new Date(dates[1]);
            let periodos = [];
            let currentDate = new Date(startDate);
            let numeroDias = (endDate.getTime() - startDate.getTime()) / milisecondsInADay;

            let calendar = await getCalendarioOperativoSemanalCalendar();
            setCalendar(calendar);

            calendar = calendar.map((item) => {
                return {
                    ...item,
                    FechaInicio: new Date(new Date(item?.FechaInicio).getTime()
                        //  - (12 * 60 * 60 * 1000)
                    ),
                    FechaFinal: new Date(new Date(item?.FechaFinal).getTime()
                        // - (12 * 60 * 60 * 1000)
                    ), // Ajustar la fecha final

                }
            })

            setNoDays(numeroDias);

            let anchoDia = timeLineConfig?.dayWidth ? timeLineConfig?.dayWidth : 10; // Valor por defecto

            switch (tipoPeriodo) {
                case 'mesesCalendarioOperativo': {
                    // anchoDia = 20; // Ajusta el ancho del día para meses
                    const startOfMonth = new Date(currentDate);
                    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
                    if (endOfMonth > endDate) endOfMonth.setTime(endDate.getTime());
                    let a = []
                    calendar.forEach((item) => {
                        a.push({
                            ...item,
                            start: item?.FechaInicio,
                            startTime: item?.FechaInicio.getTime(),
                            end: item?.FechaFinal,
                            endTime: item?.FechaFinal.getTime(),
                            noDays: ((item?.FechaFinal.getTime() - new Date(item?.FechaInicio).getTime()) / milisecondsInADay) + 1,
                            Title: item?.Mes + ' ' + item?.Anio,
                            // Title: item?.FechaInicio.toLocaleString() + ' - ' + item?.Mes  + ' - ' + item?.FechaFinal.toLocaleString() + ' - ' + ((item?.FechaFinal.getTime() - new Date(item?.FechaInicio).getTime()) / milisecondsInADay),
                        });
                    })
                    periodos = a
                    // periodos.push({
                    //     start: new Date(startOfMonth),
                    //     startTime: startOfMonth.getTime(),
                    //     end: new Date(endOfMonth),
                    //     endTime: endOfMonth.getTime(),
                    //     noDays: (endOfMonth.getTime() - startOfMonth.getTime()) / milisecondsInADay + 1,
                    //     Title: `${startOfMonth.toLocaleString('default', { month: 'long' })} ${startOfMonth.getFullYear()}`,
                    //     // DIVIDIR EL MES EN SEMANAS
                    //     // subPeriodos: getSemanasMes(startOfMonth, endOfMonth),
                    // });

                    currentDate.setMonth(currentDate.getMonth() + 1);
                    break;
                }

                default:
                    break;
            }

            // while (currentDate <= endDate) {
            //     switch (tipoPeriodo) {
            //         case 'semanas': {
            //             anchoDia = 20; // Ajusta el ancho del día para semanas
            //             const startOfWeek = new Date(currentDate);
            //             const endOfWeek = new Date(currentDate);
            //             endOfWeek.setDate(startOfWeek.getDate() + 6);
            //             if (endOfWeek > endDate) endOfWeek.setTime(endDate.getTime());
            //             const dayNum = startOfWeek.getUTCDay() || 7;
            //             startOfWeek.setUTCDate(startOfWeek.getUTCDate() + 4 - dayNum);
            //             const yearStart = new Date(Date.UTC(startOfWeek.getUTCFullYear(), 0, 1));
            //             const weekNo = Math.ceil((((startOfWeek - yearStart) / 86400000) + 1) / 7);
            //             periodos.push({
            //                 start: new Date(startOfWeek),
            //                 startTime: startOfWeek.getTime(),
            //                 end: new Date(endOfWeek),
            //                 endTime: endOfWeek.getTime(),
            //                 noDays: (endOfWeek.getTime() - startOfWeek.getTime()) / milisecondsInADay + 1,
            //                 Title: `Semana ` + weekNo,
            //             });

            //             currentDate.setDate(currentDate.getDate() + 7);
            //             break;
            //         }
            //         case 'mesesCalendarioOperativo': {
            //             anchoDia = 10; // Ajusta el ancho del día para meses
            //             const startOfMonth = new Date(currentDate);
            //             const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            //             if (endOfMonth > endDate) endOfMonth.setTime(endDate.getTime());
            //             let a  = []
            //             calendar.forEach((item) => {
            //                 // console.log({item});
            //                 a.push({
            //                     start: new Date(item?.FechaInicio),
            //                     startTime: new Date(item?.FechaInicio).getTime(),
            //                     end: new Date(item?.FechaFinal),
            //                     endTime: new Date(item?.FechaFinal).getTime(),
            //                     noDays: (new Date(item?.FechaFinal).getTime() - new Date(item?.FechaInicio).getTime()) / milisecondsInADay + 1,
            //                     Title: item?.Mes,
            //                 });
            //             })
            //             console.log(a);
            //             periodos.push({
            //                 start: new Date(startOfMonth),
            //                 startTime: startOfMonth.getTime(),
            //                 end: new Date(endOfMonth),
            //                 endTime: endOfMonth.getTime(),
            //                 noDays: (endOfMonth.getTime() - startOfMonth.getTime()) / milisecondsInADay + 1,
            //                 Title: `${startOfMonth.toLocaleString('default', { month: 'long' })} ${startOfMonth.getFullYear()}`,
            //                 // DIVIDIR EL MES EN SEMANAS
            //                 // subPeriodos: getSemanasMes(startOfMonth, endOfMonth),
            //             });

            //             currentDate.setMonth(currentDate.getMonth() + 1);
            //             break;
            //         } 
            //         case 'trimestres': {
            //             anchoDia = 5; // Ajusta el ancho del día para trimestres
            //             const startOfQuarter = new Date(currentDate);
            //             const endOfQuarter = new Date(
            //                 currentDate.getFullYear(),
            //                 currentDate.getMonth() + 3,
            //                 0
            //             );
            //             if (endOfQuarter > endDate) endOfQuarter.setTime(endDate.getTime());

            //             periodos.push({
            //                 start: new Date(startOfQuarter),
            //                 startTime: startOfQuarter.getTime(),
            //                 end: new Date(endOfQuarter),
            //                 endTime: endOfQuarter.getTime(),
            //                 noDays: (endOfQuarter.getTime() - startOfQuarter.getTime()) / milisecondsInADay + 1,
            //                 Title: `Trimestre ${startOfQuarter.toLocaleString('default', { month: 'short' })} - ${endOfQuarter.toLocaleString('default', { month: 'short' })} ${startOfQuarter.getFullYear()}`,
            //             });

            //             currentDate.setMonth(currentDate.getMonth() + 3);
            //             break;
            //         }
            //         case 'meses':
            //         default: {
            //             anchoDia = 10; // Ajusta el ancho del día para meses
            //             const startOfMonth = new Date(currentDate);
            //             const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            //             if (endOfMonth > endDate) endOfMonth.setTime(endDate.getTime());

            //             periodos.push({
            //                 start: new Date(startOfMonth),
            //                 startTime: startOfMonth.getTime(),
            //                 end: new Date(endOfMonth),
            //                 endTime: endOfMonth.getTime(),
            //                 noDays: (endOfMonth.getTime() - startOfMonth.getTime()) / milisecondsInADay + 1,
            //                 Title: `${startOfMonth.toLocaleString('default', { month: 'long' })} ${startOfMonth.getFullYear()}`,
            //                 // DIVIDIR EL MES EN SEMANAS
            //                 // subPeriodos: getSemanasMes(startOfMonth, endOfMonth),
            //             });

            //             currentDate.setMonth(currentDate.getMonth() + 1);
            //             break;
            //         }
            //     }
            // }
            setTimeLineConfig({ ...timeLineConfig, dayWidth: anchoDia });
            setTotalWidth(numeroDias * anchoDia); // Calcula el ancho total
            setPeriodos(periodos); // Actualiza los periodos
            // goToCurrentDate(); // Llama a la función para ir a la fecha actual
        }
    };

    const getSemanasMes = (startDate, endDate) => {
        const semanas = [];
        let currentDate = new Date(startDate);
        const endOfMonth = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
        let startOfWeek = new Date(currentDate);
        let endOfWeek = new Date(currentDate);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        if (endOfWeek > endOfMonth) endOfWeek.setTime(endOfMonth.getTime());
        let weekNo = 1;
        while (currentDate <= endOfMonth) {
            semanas.push({
                start: new Date(startOfWeek),
                startTime: startOfWeek.getTime(),
                end: new Date(endOfWeek),
                endTime: endOfWeek.getTime(),
                noDays: (endOfWeek.getTime() - startOfWeek.getTime()) / milisecondsInADay,
                Title: weekNo++,
            });
            currentDate.setDate(currentDate.getDate() + 7);
            startOfWeek.setDate(currentDate.getDate());
            endOfWeek.setDate(startOfWeek.getDate() + 6);
            if (endOfWeek > endOfMonth) endOfWeek.setTime(endOfMonth.getTime());
        }
        return semanas;
    }

    const changeValWidthDay = (aumenta = true) => {
        if (aumenta) {
            setTimeLineConfig({ ...timeLineConfig, dayWidth: timeLineConfig?.dayWidth + valChangeWidthDay });
            setTotalWidth(noDays * (timeLineConfig.dayWidth + valChangeWidthDay));
        } else {
            if (timeLineConfig?.dayWidth <= 10) return;
            if (timeLineConfig?.dayWidth <= 20 && timeLineConfig?.showDays) return;
            setTimeLineConfig({ ...timeLineConfig, dayWidth: timeLineConfig?.dayWidth - valChangeWidthDay });
            setTotalWidth(noDays * (timeLineConfig.dayWidth - valChangeWidthDay));
        }
    };

    const setLinePeriodos = () => {
        let timeLineHeader = periodos.map((periodo, index) => {
            let widthPeriodo = 0;
            let noDiasPeriodo = periodo.noDays;
            widthPeriodo = noDiasPeriodo * timeLineConfig?.dayWidth;
            return (
                <div key={index} className='Timeline-lapse' style={{ width: widthPeriodo }}>
                    <div className='Timeline-Header'
                    >
                        <div className='Timeline-Item-Header-Title' style={{ height: heightHeaderLine }}>
                            {periodo.Title}
                        </div>
                        <div className='d-flex' style={{ height: heightHeaderLine }}>
                            {getWeeks(periodo, true)}
                        </div>
                        <div className='d-flex'>
                            {getDays(periodo, true)}
                        </div>
                    </div>
                </div>
            );
        });
        return (
            <div className='Timeline-Items d-flex' > {timeLineHeader} </div>
        );
    };


    const goToDate = (date = new Date()) => {
        let left = ((new Date(date).getTime() - new Date(dates[0]).getTime()) / milisecondsInADay) * timeLineConfig?.dayWidth;
        scrollHorizontalRef.current.scrollTo({
            left: left - (dividerPosition * 1.8),
            behavior: 'smooth'
        });
    }



    const getDays = (periodo, showNoDia) => {
        if (!timeLineConfig?.showDays) return;
        let a = [];
        for (let i = 0; i < periodo.noDays; i++) {
            let fechaInicio = new Date(periodo.start);
            let fechaActual = new Date(fechaInicio.getTime() + (i * milisecondsInADay));
            let dia = fechaActual.getDate();
            let isCurrentDate = fechaActual.getMonth() === new Date().getMonth() && fechaActual.getFullYear() === new Date().getFullYear() && fechaActual.getDate() === new Date().getDate();
            a.push(
                <div className={'dia' + (isCurrentDate ? ' currentDate' : '')}
                    style={{
                        width: timeLineConfig?.dayWidth,
                        height: showNoDia ? heightHeaderLine : '100%'
                    }}
                    i>
                    {showNoDia ? dia : ''}
                </div>
            )

        }
        return a;
    }

    const getWeeks = (periodo, showNoSemana) => {
        let a = [];
        if (!timeLineConfig?.showWeeks) return;
        if (periodo?.semanas.length > 0) {
            periodo.semanas.forEach((semana, index) => {
                let widthSemana = 0;
                let noDiasSemana = semana.noDays;
                widthSemana = noDiasSemana * timeLineConfig?.dayWidth;
                a.push(<div key={index} className='semana' style={{ width: widthSemana, height: showNoSemana ? heightHeaderLine - 6 : '100%' }} >
                    <div className='semana-title'>
                        <div className='semana-title-text'>
                            {showNoSemana ? semana?.Semana : ''}
                        </div>
                    </div>
                </div>)
            }
            )
        }
        return a;
    }


    const optionsButtons = (
        <div className={'d-flex gap box-buttons-timeline'}>
            <div className={'d-flex gap box-buttons-timeline-options ' + (timeLineConfig?.showOptions ? 'show' : 'hide')}>

                <div className='d-flex gap '>
                    {timeLineConfig?.showOptions ?
                        <SplitButton
                            model={shortSplitButton}
                            icon={`pi ${timeLineConfig?.sortDirection === 'desc' ? 'pi-sort-amount-up' : 'pi-sort-amount-down'}`}
                            className="p-button-raised p-button-info"
                            onClick={e => chageSortDirection()}
                        />
                        :
                        <Button
                            icon={`pi ${timeLineConfig?.sortDirection === 'desc' ? 'pi-sort-amount-up' : 'pi-sort-amount-down'}`}
                            className="p-button-raised p-button-info"
                            onClick={e => chageSortDirection()}
                            rounded
                        />
                    }
                    <Button
                        
                        icon='pi pi-calendar'
                        rounded
                        className="p-button-raised p-button-info"
                        onClick={() => goToDate()}
                        tooltip={'Ir a la fecha actual'}
                    />
                </div>
                {timeLineConfig?.showOptions &&
                    <div className='d-flex gap'>
                        {/* <CalendarWeek
                    date={dates}
                    setDate={setDates}
                    selectionMode='range'
                /> */}
                        {/* boton ordenar */}
                        <Button
                            // label='Aumentar tamaño'
                            icon="pi pi-plus"
                            rounded
                            // text
                            className="p-button-raised p-button-info"
                            onClick={() => changeValWidthDay(true)}
                            tooltip='Aumentar tamaño'
                        />
                        <Button
                            // label='Disminuir tamaño'
                            icon="pi pi-minus"
                            rounded
                            // text
                            className="p-button-raised p-button-info"
                            onClick={() => changeValWidthDay(false)}
                            tooltip='Disminuir tamaño'
                        />

                        {/* EXPANDIR TODOS */}



                        {/* <Button
                    label='Semanas'
                    className="p-button-raised p-button-info"
                    onClick={() => setTipoPeriodo('semanas')}
                /> */}
                        {/* <Button
                    label='Meses'
                    className="p-button-raised p-button-info"
                    onClick={() => setTipoPeriodo('meses')}
                /> */}
                        {/* <Button
                    label='Trimestres'
                    className="p-button-raised p-button-info"
                    onClick={() => setTipoPeriodo('trimestres')}
                /> */}
                        {/* mostrar / ocultar dias, semanas, meses */}
                        <Button
                            // label='Dias'
                            rounded
                            icon={ !timeLineConfig?.showDays ? 'pi pi-eye' : 'pi pi-eye-slash'}
                            className="p-button-raised p-button-info"
                            onClick={() =>
                                setTimeLineConfig({ ...timeLineConfig, showDays: !timeLineConfig?.showDays, dayWidth: !timeLineConfig?.showDays ? 20 : timeLineConfig?.dayWidth })
                            }
                            tooltip={timeLineConfig?.showDays ? 'Ocultar dias' : 'Mostrar dias'}
                        />
                        {/* <Button
                    label='Semanas'
                    className="p-button-raised p-button-info"
                    onClick={() => setshowWeeks(!timeLineConfig.showWeeks)}
                    tooltip={timeLineConfig.showWeeks ? 'Ocultar semanas' : 'Mostrar semanas'}
                />
                <Button
                    label='Meses'
                    className="p-button-raised p-button-info"
                    onClick={() => setShowMonths(!timeLineConfig.showMonths)}
                    tooltip={timeLineConfig.showMonths ? 'Ocultar meses' : 'Mostrar meses'}
                /> */}

                    </div>}
            </div>


            <div className='d-flex gap box-buttons-timeline'>
                {/* expandir */}
                <Button
                    icon={timeLineConfig?.showOptions ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'}
                    rounded
                    // text
                    className="p-button-raised p-button-info"
                    onClick={() => setTimeLineConfig({ ...timeLineConfig, showOptions: !timeLineConfig?.showOptions })}
                // tooltip='Opciones'
                />
            </div>
        </div>


    )


    useEffect(() => {
        if (dates?.length === 2) {
            deffPeriodos(); // Llama a la función cada vez que cambie el tipo de periodo o las fechas
            // deffData(); // Llama a la función para generar datos
        }
        // getCalendarOperativo();
    }, [tipoPeriodo, dates, timeLineConfig?.showDays, timeLineConfig?.showWeeks, timeLineConfig?.showMonths]);

    useEffect(() => {
        goToDate();
        setDataFiltrada(data);
    }, [data])


    useEffect(() => {
        goToDate();
    }, [periodos, data]);

    useEffect(() => {
        if (filter) {
            const dataFiltrada = data.filter((item) => {
                return item?.Title?.toLowerCase().includes(filter.toLowerCase());
            });
            setDataFiltrada(dataFiltrada);
        } else {
            setDataFiltrada(data);
        }
    }, [filter]);

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <Loader loading={loading} />
            {optionsButtons}
            <div style={{ position: 'relative', width: '100%', height: `100%` }}>
                <div className='border' style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, overflowY: 'hidden', overflowX: 'hidden' }}>
                        <div className='rs-timeline' ref={scrollHorizontalRef}>
                            {dates?.length === 2 ?
                                <div style={{ minHeight: '100%', position: 'relative', height: 'fit-content', width: 'fit-content', flexShrink: 1, flexGrow: 1, flexBasis: 'auto', flexDirection: 'column', display: 'flex' }}>
                                    <div className='HeaderRowGroup'
                                        style={{ height: headerheight }}
                                    >
                                        <div role='row' className='rowHeaderContainer'>
                                            <div className='rowHeader d-flex' style={{ width: dividerPosition, height: headerheight, justifyContent: 'space-between', alignItems: 'center' }}>
                                                <InputText
                                                    className='filter'
                                                    value={filter}
                                                    onChange={(e) => setFilter(e.target.value)}
                                                    placeholder='Buscar...'
                                                    style={{ height: '100%', width: 'Calc(100% - 40px)' }}

                                                />
                                                {/* boton recargar la infomacion */}
                                                <Button
                                                    icon="pi pi-refresh"
                                                    // rounded
                                                    text
                                                    className="p-button-raised p-button-info"
                                                    onClick={getInfo}
                                                    tooltip='Recargar'
                                                />
                                            </div>
                                            <div className="rowHeaderContent" style={{ width: totalWidth }}>
                                                <div>{setLinePeriodos()}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='ContentRowGroup'>
                                        {
                                            dataFiltrada?.map((Item, index) => {
                                                return <TimeLineItem
                                                    key={index}
                                                    Item={Item}
                                                    dividerPosition={dividerPosition}
                                                    totalWidth={totalWidth}
                                                    dayWidth={timeLineConfig?.dayWidth}
                                                    startDate={dates[0]}
                                                    showAllChildren={showAllChildren}
                                                    getDetails={getDetails}
                                                    bodyItemContent={bodyItemContent}
                                                    childBodyItemContent={childBodyItemContent}
                                                    titleItem={titleItem}
                                                    childTitleItem={childTitleItem}
                                                    goToDate={goToDate}
                                                />;
                                            })
                                        }
                                    </div>
                                    <div className='ListCover' style={{ top: headerheight, }}>
                                        <div className="ListCover-Title" style={{ width: dividerPosition }}></div>
                                        <div className="ListCover-Body" style={{ width: totalWidth, height: `calc(100% - ${headerheight})` }} >
                                            {
                                                periodos?.map((periodo, index) => {
                                                    let widthPeriodo = 0;
                                                    let noDiasPeriodo = periodo?.noDays;
                                                    widthPeriodo = noDiasPeriodo * timeLineConfig?.dayWidth;
                                                    return (<div key={index} className='ListCover-Body-lapse' style={{ width: widthPeriodo }} >
                                                        <div className='d-flex divider'>
                                                            {getWeeks(periodo)}
                                                        </div>
                                                        <div className='d-flex divider'>
                                                            {getDays(periodo)}
                                                        </div>
                                                        {/* {getDays(periodo)} */}

                                                        {/* {periodo.subPeriodos && periodo.subPeriodos.map((subPeriodo, subIndex) => {
                                                            let widthSubPeriodo = 0;
                                                            let noDiasSubPeriodo = subPeriodo.noDays;
                                                            widthSubPeriodo = noDiasSubPeriodo * timeLineConfig.dayWidth;
                                                            return (<div key={subIndex} className='ListCover-Body-lapse' style={{ width: widthSubPeriodo }} >
                                                                <div className='ListCover-Body-lapse-Title'>
                                                                    {subPeriodo.Title}
                                                                </div>
                                                            </div>)
                                                        })} */}
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className='ListCover-CurrentDate' style={{
                                            left: (((new Date(
                                                new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 10, 0, 0, 0
                                            ).getTime() - new Date(dates[0]).getTime()) / milisecondsInADay) * timeLineConfig?.dayWidth) + dividerPosition
                                        }}>
                                            <div className='ListCover-CurrentDate-Line' style={{}}>
                                                <span className='ListCover-CurrentDate-arrow' style={{ top: headerheight }}></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='Timeline-Items' style={{ width: '100%', height: '100%', color: '#FFF' }}>
                                    <div className='Timeline-Item-Header'>
                                        <div className='Timeline-Item-Header-Title'>
                                            No hay periodos definidos
                                        </div>
                                    </div>
                                    <div className='Timeline-Item-Body'>
                                        <div className='Timeline-Item-Body-Content'>
                                            <div className='Timeline-Item-Body-Content-Title'>
                                                Selecciona un rango de fechas
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimeLine;